import { Button, Flex } from "@chakra-ui/react";
import { StatusFiltroRapido } from "@/models/consignado/proposal-billings.model";

const OPCOES: { value: StatusFiltroRapido; label: string }[] = [
  { value: "TODOS", label: "Todos" },
  { value: "ESCRITURADOS", label: "Escriturados" },
  { value: "NAO_ESCRITURADOS", label: "Não escriturados" },
  { value: "REPASSADO", label: "Repassado" },
  { value: "NAO_REPASSADO", label: "Não repassado" },
];

type Props = {
  statusFiltro: StatusFiltroRapido;
  setStatusFiltro: (status: StatusFiltroRapido) => void;
};

export default function StatusFilterBar({ statusFiltro, setStatusFiltro }: Props) {
  return (
    <Flex gap={4} flexWrap="wrap">
      {OPCOES.map((opcao) => (
        <Button
          key={opcao.value}
          size="lg"
          colorScheme="primary"
          variant={statusFiltro === opcao.value ? "solid" : "outline"}
          bg={statusFiltro === opcao.value ? undefined : "white"}
          onClick={() => setStatusFiltro(opcao.value)}
        >
          {opcao.label}
        </Button>
      ))}
    </Flex>
  );
}
